/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Button } from "antd";
import { SearchSelect } from "../core";
import StatusSelect from "./status-select";
import TagsSelect from "./tags-select";
import { useDebounce } from "hooks/useDebounce";

const UserTaskFilterComponent = ({
  organizationId,
  archived,
  variables,
  setVariables,
  setCurrentPage,
  searchUserTasksQuery,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedQuery = useDebounce(searchQuery, 500);

  useEffect(() => {
    setVariables({ ...variables, query: debouncedQuery });
  }, [debouncedQuery]);

  const onClear = () => {
    setCurrentPage(1);
    setSearchQuery("");
    //setVariables({ ...defaultVariables(organization, archived), statuses: ['IN_PROGRESS', 'CREATED'] });
  };

  return (
    <>
      <div className="__usertasktable_container">
        <div className="filter">
          <div className="label">Task</div>
          <SearchSelect
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
        </div>
        <div className="filter">
          <div className="label">Status</div>
          <StatusSelect variables={variables} setVariables={setVariables} />
        </div>
        <div className="filter">
          <div className="label">Tags</div>
          <TagsSelect setVariables={setVariables} variables={variables} />
        </div>
        <div className="buttons">
          <Button onClick={(evt) => onClear()}>Clear</Button>
        </div>
      </div>
      <style>{`
          .__usertasktable_container {
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            padding: 1em 0.5em;
          }
          .title {
            border-right: 1px solid #eee;
            font-size: 1.1em;
            color: #999;
            padding-right: 1em;
            margin-right: 1em;
          }
          .filter {
            display: flex;
            flex-direction: column;
            margin: 0.5em;
          }
          .label {
            font-size: 1.1em;
            font-weight: 400;
            margin-bottom: 0.5em;
          }
          .buttons {
            display: flex;
            flex: 1;
            padding: 1em 0.85em;
          }
        `}</style>
    </>
  );
};

export default UserTaskFilterComponent;
